module.exports = __webpack_public_path__ + "5462fdce.svg";